import {
    getGarageDetailsByCity,
    getPincodeFromUserId,
} from '@/components/fakeDoor/api';
import { Input } from '@/components/fakeDoor/components/mmv/input';
import { DarkButton } from '@acko-tech/building-blocks.ui.button';
import Cookies from 'js-cookie';
import useSwr from 'swr';

import { useEffect, useState } from 'react';
import MobileOrDesktopDialog from '@/components/common/mobileOrDesktopDialog';
import { VIEW_PAGE_ADSC_ENTER_PINCODE } from '@/analytics/events';
import { viewPageAPI } from '@/analytics/middleware';
import useOnce from '@/hooks/useOnce';
import { useSelector } from 'react-redux';
import { getUserDetails } from '@/store/modules/userDataSlice';
import GarageInfoCard from '@/components/fakeDoor/components/garageInfoCard';
import useGarageDetails from '@/components/fakeDoor/hooks/useGarageDetails';
import useQueryParam from '@/hooks/useQueryParam';
import { getUserIdFromCookie } from '@/utils/common';
import { useLoading } from '@/hooks/useLoading';
import { LOCAL_STORAGE_KEYS } from '@/constants/storageKeys';

interface Props {
    ctaHandler: (pincode: string, currentGarageId?: string) => void;
    showModal: boolean;
    closeModal?: () => void;
    type?: string;
    subText?: string;
    prefilledPincode?: string;
}

interface Garage {
    garageId: string;
    garageName: string;
    garageAddress: string;
    garageRating: number;
    pincode: string;
}

function PincodeModal({
    ctaHandler,
    showModal,
    closeModal,
    type = 'new',
    subText,
    prefilledPincode,
}: Props) {
    const queryPincode = useQueryParam('pincode');
    const [pincode, setPincode] = useState('');
    const [title, setTitle] = useState('Enter your PIN code');
    const [isManuallyEdited, setIsManuallyEdited] = useState(false);

    const [selectedGarageIndex, setSelectedGarageIndex] = useState<
        string | null
    >(null);
    const selectedGarageData = useSelector((state: any) => {
        return state.currentGarageData?.selectedGarageData;
    });
    const changeHandler = (val: string) => {
        setIsManuallyEdited(true);
        setPincode(val);
    };
    // const {
    //     data: cityGarages = [],
    //     error: errorGarageDetails,
    //     isLoading: isLoadingGarageDetails,
    // } = useSwr(
    //     type === 'edit' ? `garageDetails-${type}` : null,
    //     () => getGarageDetailsByCity(selectedGarageData?.city || 'bengaluru'),
    //     {
    //         revalidateOnFocus: false,
    //     }
    // );

    const defaultSubText =
        'This helps us show you the nearest ACKO Drive Service Centre and unlock discounts for you';

    useOnce(() => {
        viewPageAPI({
            event_name: VIEW_PAGE_ADSC_ENTER_PINCODE,
            customAttributes: {},
            isFakeDoor: true,
        });
    });

    useEffect(() => {
        const pincode = localStorage.getItem(LOCAL_STORAGE_KEYS.PINCODE);
        if (pincode) {
            setPincode(pincode);
            setTitle('Confirm your PIN code');
        }
    }, []);
    useEffect(() => {
        const getPincode = async () => {
            if (getUserIdFromCookie()) {
                try {
                    const res = await getPincodeFromUserId();
                    const pincode = res ? res.toString() : '';
                    if (pincode.length == 6) {
                        setPincode(pincode);
                        setTitle('Confirm your PIN code');
                    } else {
                        setTitle('Enter your PIN code');
                    }
                } catch {
                    setTitle('Enter your PIN code');
                }
            } else {
                setTitle('Enter your PIN code');
            }
        };
        if (prefilledPincode) {
            setPincode(prefilledPincode);
        } else if (type === 'new' && !queryPincode) {
            getPincode();
        } else {
            const pincode =
                queryPincode || localStorage.getItem('pincode') || '';
            if (pincode) {
                setPincode(pincode);
            }
        }
    }, [prefilledPincode]);

    const handleSelect = (garageId: string, pincode: string) => {
        setSelectedGarageIndex(garageId);
        setPincode(pincode);
        setIsManuallyEdited(false);
    };

    const isSelected = (id: string) => {
        return id === selectedGarageIndex;
    };

    useEffect(() => {
        const currentGarageId = localStorage.getItem('garage_id');
        if (currentGarageId) {
            setSelectedGarageIndex(currentGarageId);
        }
    }, []);

    return (
        <>
            <MobileOrDesktopDialog
                hideClose={type === 'new'}
                show={showModal}
                onClose={closeModal}
                title={type === 'edit' ? 'Change your location' : title}
            >
                <div className="text">{subText ? subText : defaultSubText}</div>
                <Input
                    type="number"
                    name="pincode"
                    label="PIN code"
                    value={
                        isManuallyEdited ? pincode : prefilledPincode || pincode
                    }
                    key={selectedGarageIndex}
                    handleInputs={(e: React.ChangeEvent<HTMLInputElement>) => {
                        changeHandler(e.target.value);
                    }}
                />
                {/* <>
                    {type === 'edit' && (
                        <div className="garage-list">
                            <div className="title">
                                Service centres in your city
                            </div>
                            {cityGarages.length > 0 &&
                                cityGarages.map((garage: Garage) => (
                                    <GarageInfoCard
                                        key={garage.garageId}
                                        garageName={garage.garageName}
                                        garageAddress={garage.garageAddress}
                                        garageRating={garage.garageRating}
                                        isSelected={isSelected(garage.garageId)}
                                        onSelect={() =>
                                            handleSelect(
                                                garage.garageId,
                                                garage.pincode
                                            )
                                        }
                                    />
                                ))}
                        </div>
                    )}
                </> */}

                <div className="cta-wrapper">
                    <DarkButton
                        disabled={
                            (isManuallyEdited
                                ? pincode
                                : prefilledPincode || pincode
                            ).toString().length != 6
                        }
                        onClick={() =>
                            ctaHandler(
                                isManuallyEdited
                                    ? pincode
                                    : prefilledPincode || pincode,
                                selectedGarageData?.id
                            )
                        }
                    >
                        Confirm
                    </DarkButton>
                </div>
            </MobileOrDesktopDialog>
            <style jsx>{`
                .heading {
                    color: #121212;
                    font-size: 20px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 28px;
                    margin: 12px 0;
                }
                .garage-list {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    padding: 20px 0;
                }
                .title {
                    color: #4b4b4b;

                    font-size: 16px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 24px;
                }
                .text {
                    color: #4b4b4b;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 24px;
                    margin-bottom: 16px;
                }
                .cta-wrapper {
                    margin-top: 24px;
                }
            `}</style>
        </>
    );
}

export default PincodeModal;
